var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};module.exports=_extends({},
require('./remx'),{
connect:require('./connect').connect,
observer:require('./observer').observer,
useConnect:require('./useConnect').useConnect,
setAccessStateStrictMode:require('./globalState').setAccessStateStrictMode});